import { createMachine } from 'xstate';

// Browser detection code remains unchanged
const isFirefoxNative = typeof InstallTrigger !== 'undefined';

const doesBrowserSupportMugShot = () => {
  return !isFirefoxNative;
};

export const mugShotNotSupported = () => {
  return !doesBrowserSupportMugShot();
};

export const common_prefixes = [
  'q_cmm_nsl1_',
  'q_cmm_nsl2_',
  'q_cmm_nsl3_',
  'q_cmm_nsl4_',
  'q_cmm_full_',
];

const build_next_gen_scan_pages = () => {
  return {
    nextgen_scan_volume: {
      on: {
        NEXT: 'nextgen_scan_ears',
      },
    },
    nextgen_scan_ears: {
      on: {
        NEXT: 'nextgen_scan_well_lit',
      },
    },
    nextgen_scan_well_lit: {
      on: {
        NEXT: 'nextgen_scan_level',
      },
    },
    nextgen_scan_level: {
      on: {
        NEXT: 'nextgen_scan_final_prep',
      },
    },
    nextgen_scan_final_prep: {
      on: {
        NEXT: 'nextgen_scan_scan_interface',
      },
    },
    nextgen_scan_scan_interface: {
      meta: {
        show_logo: false,
        headerBgColor: '#001727',
        headerLinkColor: '#75C7FF',
      },
      on: {
        NEXT: 'nextgen_scan_complete',
        FAILED: 'nextgen_scan_scan_retry',
      },
    },
    nextgen_scan_scan_retry: {
      on: {
        NEXT: 'nextgen_scan_scan_interface',
      },
    },
    nextgen_scan_complete: {},
  };
};

// Add HIPAA consent state for US region
const buildHipaaState = () => {
  if (process.env.REACT_APP_BUILD_REGION === 'US') {
    return {
      hipaa_consent: {
        on: {
          NEXT: 'nextgen_scan_volume',
          DECLINE: 'start', // Send back to start state if declined
        },
      },
    };
  }
  return {};
};

const buildNavMachine = (
  currentStep,
  overrides = []
) => {
  let next_gen_scan_pages = build_next_gen_scan_pages();
  let hipaa_states = buildHipaaState();

  // For US region, the patient page should go to HIPAA consent first
  const patientNextState = process.env.REACT_APP_BUILD_REGION === 'US' 
    ? 'hipaa_consent' 
    : 'nextgen_scan_volume';

  const pageNavigationStates = {
    initial: currentStep,
    predictableActionArguments: true,
    id: 'pageNav',
    context: {
      mugshot_enabled: true,
    },
    states: {
      start: {
        on: { NEXT: 'patient' },
      },
      patient: {
        on: { NEXT: patientNextState },
      },
      
      // Include HIPAA states
      ...hipaa_states,
      
      // Include scan pages
      ...next_gen_scan_pages,

      complete: {},
      error: {},
    },
  };

  return createMachine(pageNavigationStates);
};

const stateHasPrevious = state => {
  return state.nextEvents.indexOf('PREVIOUS') >= 0;
};

const stateHasHelp = state => {
  return state.nextEvents.indexOf('HELP') >= 0;
};

export { buildNavMachine, stateHasPrevious, stateHasHelp };
